export const STATSIG_STABLE_ID_COOKIE_NAME = 'statsigStableId';
